import { Heading } from 'braid-design-system';
import type React from 'react';

import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import type { Card } from 'src/types';

interface CardTitleProps {
  title: React.ReactNode;
  name: Card;
  loading?: boolean;
}

export const CardTitle = ({ title, name, loading }: CardTitleProps) =>
  loading ? (
    <LoadingItem type="heading" level="3" width="medium" />
  ) : (
    <Heading
      level="3"
      component="h2"
      data={{ automation: `${name}-read-title`.toLowerCase() }}
    >
      {title}
    </Heading>
  );
